import $ from 'jquery';

const eventsTypeFilterTitle = $('.default-value'),
  filterForm = $('.events-filter-form'),
  eventsFormSelect = $('.event-type'),
  eventsListWrapper = $('.events-list-wrapper'),
  webinarsListWrapper = $('.webinars-list-wrapper'),
  eventsListCardsWrapper = $('.events-list-cards-container'),
  webinarsListCardsWrapper = $('.webinars-list-cards-container'),
  formSearchField = $('.search-event '),
  searchButton = $('.search-btn '),
  count = $('.count'),
  webinarCard = $('.webinars-list-cards-container .card'),
  loadMore = $('.webinars-list-wrapper .load-more .circle'),
  eventsPreloader = $('.events-list-preloader'),
  webinarsPreloader = $('.webinars-list-preloader');
eventsTypeFilterTitle.on({
  'mouseover focusin': function () {
    $(this).addClass('opened').children('.dropdown-menu').stop().fadeIn();
  },
  'mouseout focusout': function () {
    $(this).removeClass('opened').children('.dropdown-menu').stop().fadeOut();
  },
});

count.each(function () {
  let termId = $(this).attr('data-term-id-filter');
  let amount = '(' + $('.post-type[data-term-id=' + termId + ']').length + ')';
  $(this).append(amount);
});

function eventsFilterSubmit() {
  if ($('.events-list-wrapper').length != 0) {
    let eventsFilterData = filterForm.serialize();
    $.ajax({
      type: 'POST',
      url: themeVars.ajaxUrl,
      data: {
        action: 'eventsLoad',
        data: eventsFilterData,
      },
      beforeSend: function () {
        eventsPreloader.fadeIn();
      },
      success: function (response) {
        eventsListWrapper.fadeOut(function () {
          eventsPreloader.fadeOut();
          eventsListCardsWrapper.html(response);
          eventsListWrapper.fadeIn(1000);
        });
      },
    });
  }
}

function webinarFilterSubmit() {
  $('.webinars-list-wrapper .load-more').fadeOut();
  let eventsFilterData = filterForm.serialize();
  $.ajax({
    type: 'POST',
    url: themeVars.ajaxUrl,
    data: {
      action: 'webinarsLoad',
      data: eventsFilterData,
    },
    beforeSend: function () {
      webinarsPreloader.fadeIn();
    },
    success: function (response) {
      webinarsListWrapper.fadeOut(function () {
        webinarsPreloader.fadeOut();
        webinarsListCardsWrapper.html(response);
        webinarsListWrapper.fadeIn(1000);
      });
    },
  });
}

eventsFormSelect.on('change', function () {
  eventsFormSelect.parents('.select-option').removeClass('selected');
  $(this).parents('.select-option').addClass('selected');
  filterForm.submit(eventsFilterSubmit());
});

searchButton.on('click', function () {
  filterForm.submit(eventsFilterSubmit());
  filterForm.submit(webinarFilterSubmit());
});

loadMore.on('click', function () {
  $(this).parent().fadeOut();
  webinarCard.fadeIn();
});

filterForm.on('keypress', function (e) {
  let keyPressed = e.keyCode || e.which;
  if (keyPressed === 13) {
    e.preventDefault();
    return false;
  }
});

formSearchField.on('keydown', function (e) {
  let keyPressed = e.keyCode || e.which;
  if (keyPressed === 13) {
    filterForm.submit(eventsFilterSubmit());
    filterForm.submit(webinarFilterSubmit());
  }
});
